var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "88.000000pt",
    height: "88.000000pt",
    viewBox: "0 0 88.000000 88.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,88.000000) scale(0.100000,-0.100000)",
    fill: "#9c9c9c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321 864 c-72 -19 -161 -68 -202 -110 -29 -30 -31 -36 -18 -49 13 -13 21 -10 69 26 104 79 220 110 335 90 83 -15 136 -38 205 -90 48 -36 56 -39 69 -26 13 13 11 19 -18 49 -98 102 -292 150 -440 110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 744 c-62 -19 -143 -75 -147 -102 -6 -37 23 -36 73 2 59 46 142 70 211 63 63 -6 139 -38 176 -74 31 -30 61 -25 56 9 -4 28 -85 83 -151 103 -63 19 -157 18 -218 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 626 c-45 -12 -118 -59 -118 -75 0 -5 7 -14 15 -21 12 -10 23 -6 62 19 66 44 139 44 207 0 43 -27 51 -29 64 -16 13 14 12 18 -12 42 -51 51 -141 72 -218 51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 521 c-49 -21 -60 -48 -63 -153 -5 -140 19 -188 96 -188 79 0 102 41 102 179 0 96 -1 102 -27 131 -30 32 -75 45 -108 31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 295 c-23 -58 36 -157 114 -192 44 -21 52 -29 52 -51 0 -15 5 -34 10 -42 14 -23 44 1 48 38 3 26 11 34 58 57 70 34 108 87 108 153 1 40 -2 47 -18 47 -14 0 -22 -12 -31 -50 -41 -158 -250 -157 -290 2 -13 49 -39 69 -51 38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceTest);
export default __webpack_public_path__ + "static/media/voice-test.778a375adff64324b806182067f80f06.svg";
export { ForwardRef as ReactComponent };